<template>
  <div ref="rmaProducts" class="table-content">
    <div class="table-item" v-for="(item, index) in items" :key="index">
      <new-rma-product :item="item" :dictionary="dictionary" @productOpened="$emit('productOpened', $event)" />
    </div>
  </div>
</template>

<script>
import NewRmaProduct from './NewRmaProduct'

export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    dictionary: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    NewRmaProduct
  }
}
</script>
